import { Component, input } from '@angular/core';
import { NgStyle } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    imports: [NgStyle, TranslateModule],
})
export class FooterComponent {
  isFinishedEditing = input(false);
  currentYear = new Date().getFullYear();
}
